import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { languageChange } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const TOPIC_POWER_BANK_RENTAL = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'TOPIC_POWER_BANK_RENTAL')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/cgs/api/cmsii/v1/app/configurationItem',
        method: 'POST',
        body: {
          itemKey: 'MTOPAY_TOPIC_POWER_BANK_RENTAL',
        },
        requestAction: TOPIC_POWER_BANK_RENTAL.INIT_REQUEST,
        successAction: TOPIC_POWER_BANK_RENTAL.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [TOPIC_POWER_BANK_RENTAL.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [TOPIC_POWER_BANK_RENTAL.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'topicPowerBankRental',
    reducerMap: {
      topicPowerBankRentalState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)],
    // Actions to fire when this module is added/removed
    initialActions: [languageChange('en')],
    // finalActions: []
  }
}
